import { render, staticRenderFns } from "./plan-templates.vue?vue&type=template&id=2107c4c0&scoped=true"
import script from "./plan-templates.vue?vue&type=script&lang=js"
export * from "./plan-templates.vue?vue&type=script&lang=js"
import style0 from "./plan-templates.vue?vue&type=style&index=0&id=2107c4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2107c4c0",
  null
  
)

export default component.exports